<script>
    export let sliderRight;
</script>

<section>
    <div class="main-slider-div" style="position:relative;height:85vw;">
        <div class="hero-div">
            <p class="hero-text">3100+ Heroes</p>
        </div>
        <div class="raised-div">
            <p class="hero-text">$900M+ Raised</p>
        </div>
        <div class="border-div" />
        <div class="slider">
            {#each sliderRight as data}
                <div class="sli">
                    <div class="slider-img">
                        <img src={data.image} alt="" width="100%" />
                    </div>
                    <div class="data-part">
                        <div
                            style="display: flex; justify-content: space-between;height: 12vw;align-items: baseline;
                            "
                        >
                            <div>
                                <p class="name-text">{data.person_name}</p>
                            </div>

                            <div class="logo-img">
                                <img
                                    src={data.company_logo}
                                    alt=""
                                    width={data.width}
                                />
                            </div>
                        </div>

                        <div
                            style="display: flex;     justify-content: space-between;"
                        >
                            <p class="date">{data.date}</p>
                            <p class="logo-text">{data.company_name}</p>
                        </div>
                    </div>
                </div>
            {/each}
        </div>
    </div>
</section>

<style>
    .hero-div {
        width: 37.677vw;
        height: 12.5vw;
        background: linear-gradient(74.12deg, #00204b 1.5%, #00429b 99.49%);
        border-radius: 10vw 0vw 0vw 0vw;
        border: 0.198vw solid #7cc1ff;
        position: absolute;
        left: 19.444vw;
    }
    .raised-div {
        width: 37.677vw;
        height: 12.5vw;
        background: linear-gradient(285.51deg, #3382c0 0%, #66bafb 99.38%);
        left: 56.553vw;
        border-radius: 0vw 10vw 0vw 0vw;
        border: 0.198vw solid #7cc1ff;
        border-left: none;
        position: absolute;
        top: 0vw;
    }
    .hero-text {
        font-size: 3.056vw;
        margin-top: 4.746vw;
        text-align: center;
        font-weight: 600;
        color: white;
    }
    .border-div {
        width: 84.722vw;
        height: 67.115vw;
        border: 0.398vw solid #7cc1ff;
        border-radius: 0vw 0vw 10vw 0vw;
        border-left: none;
        position: absolute;
        border-top: none;
        top: 12.3vw;
        right: 5.9vw;
    }
    .slider {
        scroll-behavior: smooth;
        display: flex;
        justify-content: space-between;
        overflow: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
        position: absolute;
        top: 19.5vw;
        width: 90vw;
        height: 60vw;
        left: 1vw;
    }
    .slider::-webkit-scrollbar {
        display: none;
    }
    .sli {
        width: 52.083vw;
        margin-right: 10vw;
        scroll-snap-align: start;
    }
    .slider-img img {
        width: 52.083vw;
        height: 38.186vw;
        border-radius: 0.331vw;
    }
    .name-text {
        font-size: 4.4vw;
        font-weight: 500;
        width: 31vw;
        line-height: 4.047vw;
        margin: 0;
    }
    .date {
        font-size: 2.814vw;
        color: rgba(0, 32, 75, 0.7);
        line-height: 1.2vw;
    }
    .data-part {
        margin-top: 2.183vw;
        justify-content: space-between;
    }
    .logo-img {
        text-align: right;
        margin-right: 1vw;
        height: 11.8vw;
    }
    .logo-text {
        font-size: 3.167vw;
        color: #3c74c0;
        line-height: 1.2vw;
        margin-right: 1vw;
    }
</style>
